import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

interface Props {
  type: 'warning' | 'info' | 'error' | 'success';
  title: string | null;
  message: string | null;
  closable?: boolean; // New attribute
}

const typeStyles = {
  warning: {
    borderColor: '#ffa000',
    backgroundColor: '#fff8e1',
    titleColor: '#ffa000',
    messageColor: '#ffb300',
  },
  info: {
    borderColor: '#0288d1',
    backgroundColor: '#e1f5fe',
    titleColor: '#0288d1',
    messageColor: '#03a9f4',
  },
  error: {
    borderColor: '#d32f2f',
    backgroundColor: '#ffebee',
    titleColor: '#d32f2f',
    messageColor: '#c73f3f',
  },
  success: {
    borderColor: '#388e3c',
    backgroundColor: '#e8f5e9',
    titleColor: '#388e3c',
    messageColor: '#4caf50',
  },
};

function CustomAlert({ type, title, message, closable = true }: Props) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const styles = typeStyles[type];

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div
      style={{
        width: '100%',
        padding: '20px',
        borderLeft: `6px solid ${styles.borderColor}`,
        borderRadius: '4px',
        backgroundColor: styles.backgroundColor,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '4px',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <h3
          style={{
            color: styles.titleColor,
            fontWeight: 'bold',
            fontSize: '16px',
          }}
        >
          {title || 'Notification'}
        </h3>
        {closable && (
          <div>
            <CloseIcon
              fontSize="small"
              stroke="currentColor"
              sx={{ color: styles.titleColor }}
              onClick={handleClose}
            />
          </div>
        )}
      </div>
      <p
        style={{
          color: styles.messageColor,
          fontSize: '14px',
        }}
      >
        {message || 'An event occurred.'}
      </p>
    </div>
  );
}

export { CustomAlert };
